import React, { Component } from "react";
import {
  Modal,
  GET,
  loading,
  NavbarCustomer,
  t
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ
import { getProfile } from "../../utils/localStorage";
import { isCustomerScopeReady } from "../../utils/customerScope";
import { formatDate, formatTime, statusColor, translateKey } from "../../utils/customerReport";

// สีเส้นขอบซ้ายของการ์ด - ล้อกับสีสถานะเดียวกับ badge
const ACCENT_COLOR = {
  primary: "#3b82f6",
  warning: "#f59e0b",
  success: "#198754",
  danger: "#dc3545",
  secondary: "#6c757d",
};

// แยกเวลาเป็น "10:00" + "AM" ตามหัวการ์ดของดีไซน์เดิม
const splitTime = (dateStr) => {
  if (!dateStr) return { time: "-", ampm: "" };
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return { time: "-", ampm: "" };
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 || 12;
  return { time: `${String(hour12).padStart(2, "0")}:${minutes}`, ampm };
};

// เวลาแบบ 24 ชม. สำหรับป้ายนัดหมายในช่องปฏิทิน - ช่องแคบใส่ AM/PM ไม่พอ ถ้าใช้ 12 ชม. เฉย ๆ 13:30 จะอ่านเป็น 01:30
const clockTime = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "-";
  return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
};

// ตัวช่วยของมุมมองปฏิทิน - ทำงานกับวันที่ตามเวลาเครื่อง (local date) ล้วน ๆ ไม่ยุ่งกับ timezone ของ backend
const isoOf = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const parseIso = (iso) => {
  const [y, m, dd] = (iso || isoOf(new Date())).split("-").map(Number);
  return new Date(y, m - 1, dd);
};
const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(d.getDate() + n);
  return x;
};

const WEEKDAY_KEYS = ["svp_sun", "svp_mon", "svp_tue", "svp_wed", "svp_thu", "svp_fri", "svp_sat"];
const MONTH_KEYS = ["svp_month_jan", "svp_month_feb", "svp_month_mar", "svp_month_apr", "svp_month_may", "svp_month_jun", "svp_month_jul", "svp_month_aug", "svp_month_sep", "svp_month_oct", "svp_month_nov", "svp_month_dec"];

// แท็บช่วงเวลา - ค่าเดียวกับพารามิเตอร์ range ที่ส่งให้ API (day / week / month)
const RANGE_TABS = [
  { key: "day", labelKey: "range_today", icon: "" },
  { key: "week", labelKey: "range_week", icon: "" },
  { key: "month", labelKey: "range_month", icon: "" },
];

export default class AppointmentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_status: "",

      // ช่วงเวลาที่กำลังดู - anchor คือวันที่อ้างอิงที่ปุ่มลูกศรเลื่อน (ทีละ 1 วัน / สัปดาห์ / เดือน)
      range: "day",
      anchor: isoOf(new Date()),

      items: [],
      days: [],
      statuses: [],
      range_start: null,
      range_end: null,
      // วันที่เลือกดูรายการในแท็บเดือน (คลิกช่องปฏิทิน)
      selected_date: isoOf(new Date()),

      modal_detail: false,
      detail: null,

      loaded: false
    };
  }

  async componentDidMount() {
    if (!isCustomerScopeReady(getProfile())) {
      loading(false);
      return;
    }

    await this.Get();
    loading(false);
  }

  Get = async () => {
    loading(true);

    const { range, anchor, filter_status } = this.state;
    const result = await GET("customer/appointments", {
      range,
      date: anchor,
      status: filter_status || "",
    });

    if (result?.status === true) {
      const data = result.data || {};
      this.setState({
        items: Array.isArray(data.items) ? data.items : [],
        days: Array.isArray(data.days) ? data.days : [],
        statuses: Array.isArray(data.statuses) ? data.statuses : [],
        range_start: data.start_date || null,
        range_end: data.end_date || null,
        loaded: true
      });
    }

    loading(false);
  };

  onChangeStatus = (value) => this.setState({ filter_status: value }, () => this.Get());

  // เปลี่ยนแท็บ = โหลดข้อมูลช่วงใหม่จาก API เสมอ (ไม่ได้กรองจากชุดเดิมฝั่งหน้าจอ)
  // แท็บ "วันนี้" รับหน้าที่ "กระโดดกลับวันนี้" แทนปุ่ม "วันนี้" เดิมที่เอาออกไปด้วย (กดซ้ำตอนอยู่แท็บนี้ก็ยังรีเซ็ตวันที่อ้างอิงกลับเป็นวันนี้ได้)
  onChangeRange = (range) => {
    if (range === "day") {
      this.setState({ range }, () => this.goToToday());
      return;
    }
    if (range === this.state.range) return;
    this.setState({ range, loaded: false }, () => this.Get());
  };

  // เลื่อนช่วงเวลาไปข้างหน้า/ถอยหลังตามหน่วยของแท็บที่เลือกอยู่
  shiftRange = (dir) => {
    const { range, anchor } = this.state;
    const base = parseIso(anchor);
    let next;

    if (range === "week") next = addDays(base, dir * 7);
    // เดือนต้องยึดวันที่ 1 - ถ้าเลื่อนจากวันที่ 31 เดือนที่ไม่มีวันนั้น JS จะทดข้ามไปอีกเดือนให้เอง
    else if (range === "month") next = new Date(base.getFullYear(), base.getMonth() + dir, 1);
    else next = addDays(base, dir);

    const nextIso = isoOf(next);
    this.setState({ anchor: nextIso, selected_date: nextIso, loaded: false }, () => this.Get());
  };

  goToToday = () => {
    const todayIso = isoOf(new Date());
    this.setState({ anchor: todayIso, selected_date: todayIso, loaded: false }, () => this.Get());
  };

  // ตัวย่อชื่อช่างสำหรับวงกลม avatar - ยกวิธีมาจากหน้า dashboard ลูกค้า (การ์ด "งานที่กำลังดำเนินการ")
  technicianInitials = (name) => {
    const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2);
    return `${parts[0][0]}${parts[1][0]}`;
  };

  // วงกลมย่อชื่อช่างซ้อนกันสูงสุด 3 วง ที่เหลือรวมเป็นป้าย +N (แพทเทิร์นเดียวกับ dashboard)
  renderTechnicianAvatars = (names, size = 28) => (
    <div className="d-flex align-items-center">
      {names.slice(0, 3).map((name, i) => (
        <span
          key={`${name}-${i}`}
          title={name}
          className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white fw-bold"
          style={{ width: size, height: size, fontSize: 11, marginLeft: i ? -8 : 0, border: "2px solid #fff" }}
        >
          {this.technicianInitials(name)}
        </span>
      ))}
      {names.length > 3 && (
        <span className="text-secondary text-12 ms-2">+{names.length - 3}</span>
      )}
    </div>
  );

  openDetail = (item) => this.setState({ modal_detail: true, detail: item });

  closeDetail = () => this.setState({ modal_detail: false, detail: null });

  // ข้อความบรรทัดล่างของการ์ด - เช็คอินแล้วบอกเวลาจริง ยังไม่เช็คอินบอกช่วงเวลาที่นัดไว้
  checkInText = (item) => {
    if (item.checkin_at) return `${t("technician_checked_in_at")} ${formatTime(item.checkin_at)}`;
    if (item.start_date && item.end_date) {
      return `${t("technician_will_arrive_between")} ${formatTime(item.start_date)} - ${formatTime(item.end_date)}`;
    }
    if (item.start_date) return `${t("scheduled_at")} ${formatTime(item.start_date)}`;
    return t("not_scheduled");
  };

  // ป้ายหัวช่วงเวลาบนแถบเลื่อน - รูปแบบต่างกันตามแท็บ (วัน / ช่วงสัปดาห์ / เดือน)
  rangeLabel = () => {
    const { range, anchor } = this.state;
    const date = parseIso(anchor);
    const monthName = (d) => t(MONTH_KEYS[d.getMonth()]);

    if (range === "month") return `${monthName(date)} ${date.getFullYear()}`;

    if (range === "week") {
      const start = addDays(date, -date.getDay());
      const end = addDays(start, 6);
      const sameMonth = start.getMonth() === end.getMonth();
      const left = `${start.getDate()} ${monthName(start)}`;
      const right = sameMonth ? `${end.getDate()} ${monthName(end)}` : `${end.getDate()} ${monthName(end)}`;
      return `${left} - ${right} ${end.getFullYear()}`;
    }

    return `${date.getDate()} ${monthName(date)} ${date.getFullYear()}`;
  };

  dayLabel = (iso) => {
    const date = parseIso(iso);
    return `${t(WEEKDAY_KEYS[date.getDay()])} ${date.getDate()} ${t(MONTH_KEYS[date.getMonth()])} ${date.getFullYear()}`;
  };

  renderCard = (item, muted = false) => {
    const color = statusColor(item.status);
    const { time, ampm } = splitTime(item.start_date);

    return (
      <div key={item.uid} className={`card border-0 rounded-4 shadow-sm bg-white overflow-hidden ${muted ? "opacity-75" : ""}`}>
        <div className="d-flex border-start border-5" style={{ borderColor: ACCENT_COLOR[color] || ACCENT_COLOR.secondary }}>
          <div className="py-4 px-2 text-center border-end border-light" style={{ width: '110px' }}>
            <h4 className="fw-bold text-dark mb-0 text-nowrap">{time}</h4>
            <div className="text-secondary text-12 fw-bold">{ampm}</div>
          </div>
          <div className="p-4 flex-grow-1">
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div>
                <h5 className="fw-bold text-dark mb-1">{item.title || "-"}</h5>
                <div className="text-secondary text-14">{item.location || item.asset_name || "-"}</div>
              </div>
              <div className="text-end">
                <span className={`badge bg-${color}-light text-${color} rounded-pill px-3 py-1 fw-bold text-10 border border-${color} border-opacity-10 mb-1`}>
                  <span className="icon me-1">{item.checkin_at ? "" : ""}</span> {translateKey(item.status)}
                </span>
                <div className="text-secondary text-10">{item.wo_number || "-"}</div>
              </div>
            </div>
            <div className="d-flex align-items-center gap-4 text-secondary text-13 mt-3">
              <div className="d-flex align-items-center">
                <span className="icon me-1">{""}</span> {t("technician")}:
                <span className="ms-1">
                  {item.technician_names?.length
                    ? this.renderTechnicianAvatars(item.technician_names)
                    : <strong>{t("unassigned_technician")}</strong>}
                </span>
              </div>
              <span><span className="icon me-1">{""}</span> {t("est_duration")}: <strong>{item.duration_text || "-"}</strong></span>
            </div>
            <hr className="text-light my-3" />
            <div className="d-flex justify-content-between align-items-center">
              <div className="text-secondary text-12 d-flex align-items-center">
                <span className="icon me-2">{""}</span> {this.checkInText(item)}
              </div>
              <button className="btn btn-link text-primary text-decoration-none fw-bold p-0 text-13" onClick={() => this.openDetail(item)}>
                <span className="icon me-1">{""}</span> {t("view_details")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  emptyCard = (messageKey) => (
    <div className="card border-0 rounded-4 shadow-sm p-4 bg-white text-center text-secondary">
      {this.state.loaded ? t(messageKey) : t("loading")}
    </div>
  );

  // แท็บ "วันนี้" - รายการของวันเดียว
  renderDayView = () => {
    const { items } = this.state;

    return (
      <div className="d-flex flex-column gap-3">
        {items.length === 0 ? this.emptyCard("no_appointments_this_day") : items.map((item) => this.renderCard(item))}
      </div>
    );
  };

  // แท็บ "สัปดาห์" - แยกหัวข้อรายวัน เฉพาะวันที่มีนัดจริง (ถ้าโชว์ครบ 7 วันจะเต็มไปด้วยกล่อง "ไม่มีนัดหมาย" จนหาของจริงไม่เจอ)
  renderWeekView = () => {
    const { days } = this.state;
    const todayIso = isoOf(new Date());
    const daysWithItems = days.filter((day) => day.items.length > 0);

    if (!daysWithItems.length) return this.emptyCard("no_appointments_this_week");

    return (
      <div className="d-flex flex-column gap-4">
        {daysWithItems.map((day) => (
          <div key={day.date}>
            <h6 className={`fw-bold mb-3 d-flex align-items-center ${day.date === todayIso ? "text-primary" : "text-dark"}`}>
              <span className="icon me-2">{""}</span>
              {this.dayLabel(day.date)}
              {day.count > 0 && (
                <span className="badge bg-primary-light text-primary rounded-pill ms-2 fw-bold text-10">{day.count}</span>
              )}
            </h6>
            <div className="d-flex flex-column gap-3">
              {day.items.map((item) => this.renderCard(item))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  selectCalendarDate = (iso) => this.setState({ selected_date: iso });

  // แท็บ "เดือน" - ปฏิทินทั้งเดือน (6 สัปดาห์) + รายการของวันที่เลือก
  renderMonthView = () => {
    const { anchor, selected_date, days, loaded } = this.state;
    const anchorDate = parseIso(anchor);
    const firstOfMonth = new Date(anchorDate.getFullYear(), anchorDate.getMonth(), 1);
    const gridStart = addDays(firstOfMonth, -firstOfMonth.getDay());
    const weeks = [];
    for (let w = 0; w < 6; w++) weeks.push([0, 1, 2, 3, 4, 5, 6].map((i) => addDays(gridStart, w * 7 + i)));

    const todayIso = isoOf(new Date());
    const itemsByDate = days.reduce((acc, day) => ({ ...acc, [day.date]: day.items }), {});
    const selectedItems = itemsByDate[selected_date] || [];
    const selectedDateObj = parseIso(selected_date);

    return (
      <>
        <div className="card border-0 rounded-4 shadow-sm bg-white p-4 mb-4">
          <div className="table-responsive">
            <table className="table table-bordered mb-0" style={{ tableLayout: "fixed" }}>
              <thead>
                <tr>
                  {WEEKDAY_KEYS.map((key) => (
                    <th key={key} className="text-center text-secondary text-13 bg-light">{t(key)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {weeks.map((week, wi) => (
                  <tr key={wi} style={{ height: "110px" }}>
                    {week.map((d) => {
                      const iso = isoOf(d);
                      const inMonth = d.getMonth() === anchorDate.getMonth();
                      const isToday = iso === todayIso;
                      const isSelected = iso === selected_date;
                      const dayItems = itemsByDate[iso] || [];
                      return (
                        <td
                          key={iso}
                          className="p-2 align-top"
                          role="button"
                          style={{ backgroundColor: isSelected ? "#EAF2FE" : inMonth ? "#fff" : "#F8FAFC", cursor: "pointer" }}
                          onClick={() => this.selectCalendarDate(iso)}
                        >
                          <div className={`text-13 mb-1 ${isToday ? "fw-bold text-primary" : inMonth ? "text-dark" : "text-secondary"}`}>
                            {isToday ? (
                              <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white" style={{ width: 22, height: 22, fontSize: 12 }}>{d.getDate()}</span>
                            ) : (
                              d.getDate()
                            )}
                          </div>
                          {dayItems.length > 0 && (
                            <div className="d-flex flex-column gap-1">
                              {/* กดที่นัดหมายในช่องปฏิทินเพื่อเปิดรายละเอียดได้เลย ไม่ต้องเลื่อนไปหารายการด้านล่าง */}
                              {dayItems.slice(0, 2).map((item) => {
                                const accent = ACCENT_COLOR[statusColor(item.status)] || ACCENT_COLOR.secondary;
                                return (
                                  <button
                                    key={item.uid}
                                    type="button"
                                    className="btn btn-sm text-start p-1 border-0 rounded-2 w-100 text-truncate"
                                    title={`${clockTime(item.start_date)} ${item.title || ""}`}
                                    style={{ backgroundColor: `${accent}1A`, borderLeft: `3px solid ${accent}`, fontSize: "10px", lineHeight: 1.3 }}
                                    onClick={(e) => { e.stopPropagation(); this.selectCalendarDate(iso); this.openDetail(item); }}
                                  >
                                    <span className="fw-bold text-dark">{clockTime(item.start_date)}</span>{" "}
                                    <span className="text-secondary">{item.title || item.wo_number || "-"}</span>
                                  </button>
                                );
                              })}
                              {dayItems.length > 2 && (
                                <span className="text-primary fw-bold" style={{ fontSize: "10px" }}>+{dayItems.length - 2} {t("svp_more")}</span>
                              )}
                            </div>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mb-4">
          <h6 className="fw-bold text-dark mb-3 d-flex align-items-center">
            <span className="icon text-primary me-2">{""}</span>
            {t("appointments_on")} {selectedDateObj.getDate()} {t(MONTH_KEYS[selectedDateObj.getMonth()])} {selectedDateObj.getFullYear()}
          </h6>
          <div className="d-flex flex-column gap-3">
            {selectedItems.length === 0 ? (
              <div className="card border-0 rounded-4 shadow-sm p-4 bg-white text-center text-secondary">
                {loaded ? t("no_appointments_this_day") : t("loading")}
              </div>
            ) : selectedItems.map((item) => this.renderCard(item))}
          </div>
        </div>
      </>
    );
  };

  render() {
    const { range, statuses, filter_status, items, modal_detail, detail } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        <div className="body p-4 mt-3">

          {/* แถบเลื่อนช่วงเวลา + แท็บ วันนี้ / สัปดาห์ / เดือน */}
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
            <div className="d-flex align-items-center gap-3">
              <div className="d-flex align-items-center bg-white rounded-3 shadow-sm border border-light px-2 py-1">
                <button className="btn btn-sm btn-white border-0 text-secondary" onClick={() => this.shiftRange(-1)} data-testid="range-prev">
                  <span className="icon">{""}</span>
                </button>
                <span className="fw-bold text-dark text-16 px-3 text-nowrap" data-testid="range-label">{this.rangeLabel()}</span>
                <button className="btn btn-sm btn-white border-0 text-secondary" onClick={() => this.shiftRange(1)} data-testid="range-next">
                  <span className="icon">{""}</span>
                </button>
              </div>

              <div className="btn-group bg-white p-1 rounded-3 shadow-sm border border-light">
                {RANGE_TABS.map((tab) => (
                  <button
                    key={tab.key}
                    data-testid={`range-tab-${tab.key}`}
                    className={`btn btn-sm px-3 rounded-2 fw-bold border-0 ${range === tab.key ? "btn-primary" : "btn-white text-secondary"}`}
                    onClick={() => this.onChangeRange(tab.key)}
                  >
                    <span className="icon me-1">{tab.icon}</span> {t(tab.labelKey)}
                  </button>
                ))}
              </div>
            </div>

            <div className="d-flex align-items-center gap-2">
              <span className="text-secondary text-14">{t("filter")}:</span>
              <select
                className="form-select wpx-180 rounded-3 border-light shadow-none bg-white fw-bold text-dark"
                value={filter_status}
                onChange={(e) => this.onChangeStatus(e.target.value)}
              >
                <option value="">{t("all_appointments")}</option>
                {statuses.map((status) => (
                  <option key={status} value={status}>{translateKey(status)}</option>
                ))}
              </select>
            </div>
          </div>

          {/* จำนวนนัดหมายของช่วงที่เลือก */}
          <div className="text-secondary text-14 mb-3">
            {t("appointments_found")}: <strong className="text-dark">{items.length}</strong>
          </div>

          {range === "month" ? this.renderMonthView() : range === "week" ? this.renderWeekView() : this.renderDayView()}

        </div>

        {/* Detail Modal */}
        <Modal show={modal_detail} onHide={this.closeDetail} size="lg" centered>
          <Modal.Header className="border-0 pb-2">
            <Modal.Title className="fw-bold">{t("appointment_details")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!detail ? (
              <div className="text-center text-secondary py-5">{t("no_data")}</div>
            ) : (
              <div className="row g-3">
                {[
                  { label: "wo_number", value: detail.wo_number },
                  { label: "service", value: detail.title },
                  { label: "asset", value: detail.asset_name },
                  { label: "location", value: detail.location },
                  {
                    label: "technician",
                    value: detail.technician_names?.length
                      ? this.renderTechnicianAvatars(detail.technician_names, 24)
                      : t("unassigned_technician"),
                  },
                  { label: "status", value: translateKey(detail.status) },
                  { label: "date_time", value: `${formatDate(detail.start_date)} ${formatTime(detail.start_date)}`.trim() },
                  { label: "est_duration", value: detail.duration_text },
                  { label: "checked_in", value: detail.checkin_at ? formatTime(detail.checkin_at) : "-" },
                ].map((row) => (
                  <div className="col-md-6" key={row.label}>
                    <div className="text-secondary text-12 fw-bold">{t(row.label)}</div>
                    <div className="text-dark text-14">{row.value || "-"}</div>
                  </div>
                ))}
                {detail.problem_detail && (
                  <div className="col-12">
                    <div className="text-secondary text-12 fw-bold">{t("problem_detail")}</div>
                    <div className="text-dark text-14">{detail.problem_detail}</div>
                  </div>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="border-0">
            <button className="btn btn-white border px-3 py-2 fw-bold rounded-3" onClick={this.closeDetail}>
              {t("close")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
